import { useEffect } from 'react';
import { ErrorBoundary as BaseErrorBoundary } from 'react-error-boundary';

import { IntentionSettingButton } from '@grow-therapy-team/seedling-components';

import { useTrackEvent } from '../../segment/segment';
import { EventTypeEnum } from '../../segment/types';
import { IntentionUse } from './useIntentionUse';

function ErrorBoundary({ children }: { children: React.ReactNode }) {
  return <BaseErrorBoundary FallbackComponent={() => null}>{children}</BaseErrorBoundary>;
}

export const IntentionSettingButtonWrapper = ({
  use,
  onClick,
  clientName,
  appointmentShortId,
}: {
  use: IntentionUse;
  onClick: () => void;
  clientName: string;
  appointmentShortId: string;
}) => {
  const { userViewed } = useTrackEvent();

  //   Log segment event every time the provider sees the not-set variant
  useEffect(() => {
    if (use && new Set(['not-set', 'not-set-active']).has(use)) {
      userViewed(EventTypeEnum.INTENTION_SETTING_PILL_VIEWED, {
        appointmentShortId: appointmentShortId || '',
      });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [use, appointmentShortId]);

  return (
    <ErrorBoundary>
      <IntentionSettingButton use={use} onClick={onClick} clientName={clientName} />
    </ErrorBoundary>
  );
};
